var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShieldSecurity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.919 2.16324L5.17386 4.31507C4.07705 4.73291 3.17871 6.02818 3.17871 7.20856V15.6697C3.17871 16.5158 3.73234 17.6335 4.41132 18.1349L10.1565 22.4281C11.1697 23.1906 12.8306 23.1906 13.8439 22.4281L19.5891 18.1349C20.268 17.623 20.8217 16.5158 20.8217 15.6697V7.20856C20.8217 6.03863 19.9233 4.73291 18.8265 4.32552L13.0813 2.17368C12.4964 1.94388 11.5145 1.94388 10.919 2.16324Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3691 10.4251V9.76926C15.3691 8.93369 15.3691 6.39999 11.9998 6.39999C8.63053 6.39999 8.63053 8.93369 8.63053 9.76926V10.4251C7.53439 10.6677 7.16602 11.3775 7.16602 12.9139V13.8124C7.16602 15.789 7.77698 16.4 9.75362 16.4H14.246C16.2226 16.4 16.8336 15.789 16.8336 13.8124V12.9139C16.8336 11.3775 16.4652 10.6677 15.3691 10.4251ZM14.0214 10.3263H9.97824V9.76926C9.97824 8.4575 10.3017 7.7477 11.9998 7.7477C13.6979 7.7477 14.0214 8.4575 14.0214 9.76926V10.3263Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShieldSecurity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-shield-security.4de5bb3a1ecafc4ed195ece02214f36e.svg";